const rawPowe_used=[
'2022-10-01 00:00:00+01:00','700.0',
'2022-10-01 00:15:00+01:00','720.0',
'2022-10-01 00:30:00+01:00','742.5',
'2022-10-01 00:45:00+01:00','700.0',
'2022-10-01 01:00:00+01:00','690.0',
'2022-10-01 01:15:00+01:00','715.0',
'2022-10-01 01:30:00+01:00','727.5',
'2022-10-01 01:45:00+01:00','710.0',
'2022-10-01 02:00:00+01:00','695.0',
'2022-10-01 02:15:00+01:00','660.0',
'2022-10-01 02:30:00+01:00','770.0',
'2022-10-01 02:45:00+01:00','727.5',
'2022-10-01 03:00:00+01:00','705.0',
'2022-10-01 03:15:00+01:00','715.0',
'2022-10-01 03:30:00+01:00','780.0',
'2022-10-01 03:45:00+01:00','705.0',
'2022-10-01 04:00:00+01:00','700.0',
'2022-10-01 04:15:00+01:00','705.0',
'2022-10-01 04:30:00+01:00','705.0',
'2022-10-01 04:45:00+01:00','725.0',
'2022-10-01 05:00:00+01:00','700.0',
'2022-10-01 05:15:00+01:00','690.0',
'2022-10-01 05:30:00+01:00','705.0',
'2022-10-01 05:45:00+01:00','710.0',
'2022-10-01 06:00:00+01:00','735.0',
'2022-10-01 06:15:00+01:00','665.0',
'2022-10-01 06:30:00+01:00','780.0',
'2022-10-01 06:45:00+01:00','720.0',
'2022-10-01 07:00:00+01:00','720.0',
'2022-10-01 07:15:00+01:00','730.0',
'2022-10-01 07:30:00+01:00','745.0',
'2022-10-01 07:45:00+01:00','1045.0',
'2022-10-01 08:00:00+01:00','1210.0',
'2022-10-01 08:15:00+01:00','1370.0',
'2022-10-01 08:30:00+01:00','1275.0',
'2022-10-01 08:45:00+01:00','1232.5',
'2022-10-01 09:00:00+01:00','1047.5',
'2022-10-01 09:15:00+01:00','1160.0',
'2022-10-01 09:30:00+01:00','1340.0',
'2022-10-01 09:45:00+01:00','1505.0',
'2022-10-01 10:00:00+01:00','1870.0',
'2022-10-01 10:15:00+01:00','1980.0',
'2022-10-01 10:30:00+01:00','2095.0',
'2022-10-01 10:45:00+01:00','2227.5',
'2022-10-01 11:00:00+01:00','2330.0',
'2022-10-01 11:15:00+01:00','2225.0',
'2022-10-01 11:30:00+01:00','2055.0',
'2022-10-01 11:45:00+01:00','2285.0',
'2022-10-01 12:00:00+01:00','2542.5',
'2022-10-01 12:15:00+01:00','2730.0',
'2022-10-01 12:30:00+01:00','2747.5',
'2022-10-01 12:45:00+01:00','2785.0',
'2022-10-01 13:00:00+01:00','2790.0',
'2022-10-01 13:15:00+01:00','2647.5',
'2022-10-01 13:30:00+01:00','2670.0',
'2022-10-01 13:45:00+01:00','2727.5',
'2022-10-01 14:00:00+01:00','2827.5',
'2022-10-01 14:15:00+01:00','2905.0',
'2022-10-01 14:30:00+01:00','2882.5',
'2022-10-01 14:45:00+01:00','2797.5',
'2022-10-01 15:00:00+01:00','2602.5',
'2022-10-01 15:15:00+01:00','2332.5',
'2022-10-01 15:30:00+01:00','2240.0',
'2022-10-01 15:45:00+01:00','2260.0',
'2022-10-01 16:00:00+01:00','2300.0',
'2022-10-01 16:15:00+01:00','2312.5',
'2022-10-01 16:30:00+01:00','2237.5',
'2022-10-01 16:45:00+01:00','2145.0',
'2022-10-01 17:00:00+01:00','2030.0',
'2022-10-01 17:15:00+01:00','1702.5',
'2022-10-01 17:30:00+01:00','1575.0',
'2022-10-01 17:45:00+01:00','1382.5',
'2022-10-01 18:00:00+01:00','1655.0',
'2022-10-01 18:15:00+01:00','1445.0',
'2022-10-01 18:30:00+01:00','1010.0',
'2022-10-01 18:45:00+01:00','1030.0',
'2022-10-01 19:00:00+01:00','855.0',
'2022-10-01 19:15:00+01:00','735.0',
'2022-10-01 19:30:00+01:00','747.5',
'2022-10-01 19:45:00+01:00','740.0',
'2022-10-01 20:00:00+01:00','812.5',
'2022-10-01 20:15:00+01:00','945.0',
'2022-10-01 20:30:00+01:00','970.0',
'2022-10-01 20:45:00+01:00','945.0',
'2022-10-01 21:00:00+01:00','945.0',
'2022-10-01 21:15:00+01:00','787.5',
'2022-10-01 21:30:00+01:00','740.0',
'2022-10-01 21:45:00+01:00','810.0',
'2022-10-01 22:00:00+01:00','750.0',
'2022-10-01 22:15:00+01:00','742.5',
'2022-10-01 22:30:00+01:00','720.0',
'2022-10-01 22:45:00+01:00','660.0',
'2022-10-01 23:00:00+01:00','742.5',
'2022-10-01 23:15:00+01:00','710.0',
'2022-10-01 23:30:00+01:00','727.5',
'2022-10-01 23:45:00+01:00','740.0',
];
const rawPowe_PV=[
'2022-10-01 00:00:00+01:00','0.0',
'2022-10-01 00:15:00+01:00','0.0',
'2022-10-01 00:30:00+01:00','0.0',
'2022-10-01 00:45:00+01:00','0.0',
'2022-10-01 01:00:00+01:00','0.0',
'2022-10-01 01:15:00+01:00','0.0',
'2022-10-01 01:30:00+01:00','0.0',
'2022-10-01 01:45:00+01:00','0.0',
'2022-10-01 02:00:00+01:00','0.0',
'2022-10-01 02:15:00+01:00','0.0',
'2022-10-01 02:30:00+01:00','0.0',
'2022-10-01 02:45:00+01:00','0.0',
'2022-10-01 03:00:00+01:00','0.0',
'2022-10-01 03:15:00+01:00','0.0',
'2022-10-01 03:30:00+01:00','0.0',
'2022-10-01 03:45:00+01:00','0.0',
'2022-10-01 04:00:00+01:00','0.0',
'2022-10-01 04:15:00+01:00','0.0',
'2022-10-01 04:30:00+01:00','0.0',
'2022-10-01 04:45:00+01:00','0.0',
'2022-10-01 05:00:00+01:00','0.0',
'2022-10-01 05:15:00+01:00','0.0',
'2022-10-01 05:30:00+01:00','0.0',
'2022-10-01 05:45:00+01:00','0.0',
'2022-10-01 06:00:00+01:00','0.0',
'2022-10-01 06:15:00+01:00','0.0',
'2022-10-01 06:30:00+01:00','0.0',
'2022-10-01 06:45:00+01:00','0.0',
'2022-10-01 07:00:00+01:00','0.0',
'2022-10-01 07:15:00+01:00','0.0',
'2022-10-01 07:30:00+01:00','0.0',
'2022-10-01 07:45:00+01:00','0.0',
'2022-10-01 08:00:00+01:00','0.0',
'2022-10-01 08:15:00+01:00','0.0',
'2022-10-01 08:30:00+01:00','0.0',
'2022-10-01 08:45:00+01:00','20.0',
'2022-10-01 09:00:00+01:00','137.5',
'2022-10-01 09:15:00+01:00','447.5',
'2022-10-01 09:30:00+01:00','795.0',
'2022-10-01 09:45:00+01:00','1290.0',
'2022-10-01 10:00:00+01:00','1795.0',
'2022-10-01 10:15:00+01:00','2185.0',
'2022-10-01 10:30:00+01:00','2570.0',
'2022-10-01 10:45:00+01:00','2920.0',
'2022-10-01 11:00:00+01:00','3217.5',
'2022-10-01 11:15:00+01:00','3400.0',
'2022-10-01 11:30:00+01:00','3795.0',
'2022-10-01 11:45:00+01:00','3380.0',
'2022-10-01 12:00:00+01:00','3870.0',
'2022-10-01 12:15:00+01:00','4442.5',
'2022-10-01 12:30:00+01:00','4585.0',
'2022-10-01 12:45:00+01:00','4722.5',
'2022-10-01 13:00:00+01:00','4870.0',
'2022-10-01 13:15:00+01:00','4960.0',
'2022-10-01 13:30:00+01:00','5037.5',
'2022-10-01 13:45:00+01:00','5070.0',
'2022-10-01 14:00:00+01:00','5117.5',
'2022-10-01 14:15:00+01:00','5152.5',
'2022-10-01 14:30:00+01:00','5135.0',
'2022-10-01 14:45:00+01:00','5020.0',
'2022-10-01 15:00:00+01:00','4987.5',
'2022-10-01 15:15:00+01:00','4877.5',
'2022-10-01 15:30:00+01:00','4802.5',
'2022-10-01 15:45:00+01:00','4615.0',
'2022-10-01 16:00:00+01:00','4500.0',
'2022-10-01 16:15:00+01:00','4360.0',
'2022-10-01 16:30:00+01:00','4112.5',
'2022-10-01 16:45:00+01:00','3917.5',
'2022-10-01 17:00:00+01:00','3670.0',
'2022-10-01 17:15:00+01:00','3385.0',
'2022-10-01 17:30:00+01:00','3057.5',
'2022-10-01 17:45:00+01:00','2690.0',
'2022-10-01 18:00:00+01:00','2107.5',
'2022-10-01 18:15:00+01:00','2090.0',
'2022-10-01 18:30:00+01:00','1315.0',
'2022-10-01 18:45:00+01:00','515.0',
'2022-10-01 19:00:00+01:00','540.0',
'2022-10-01 19:15:00+01:00','520.0',
'2022-10-01 19:30:00+01:00','240.0',
'2022-10-01 19:45:00+01:00','167.5',
'2022-10-01 20:00:00+01:00','40.0',
'2022-10-01 20:15:00+01:00','2.5',
'2022-10-01 20:30:00+01:00','0.0',
'2022-10-01 20:45:00+01:00','0.0',
'2022-10-01 21:00:00+01:00','0.0',
'2022-10-01 21:15:00+01:00','0.0',
'2022-10-01 21:30:00+01:00','0.0',
'2022-10-01 21:45:00+01:00','0.0',
'2022-10-01 22:00:00+01:00','0.0',
'2022-10-01 22:15:00+01:00','0.0',
'2022-10-01 22:30:00+01:00','0.0',
'2022-10-01 22:45:00+01:00','0.0',
'2022-10-01 23:00:00+01:00','0.0',
'2022-10-01 23:15:00+01:00','0.0',
'2022-10-01 23:30:00+01:00','0.0',
'2022-10-01 23:45:00+01:00','0.0',];

const rawTariff1=[
    '2022-09-11 00:00:00+02:00','208.67',
    '2022-09-11 01:00:00+02:00','190.56',
    '2022-09-11 02:00:00+02:00','189.01',
    '2022-09-11 03:00:00+02:00','186.75',
    '2022-09-11 04:00:00+02:00','184.9',
    '2022-09-11 05:00:00+02:00','183.45',
    '2022-09-11 06:00:00+02:00','183.4',
    '2022-09-11 07:00:00+02:00','179.43',
    '2022-09-11 08:00:00+02:00','156.44',
    '2022-09-11 09:00:00+02:00','176.43',
    '2022-09-11 10:00:00+02:00','135.33',
    '2022-09-11 11:00:00+02:00','117.59',
    '2022-09-11 12:00:00+02:00','111.76',
    '2022-09-11 13:00:00+02:00','108.07',
    '2022-09-11 14:00:00+02:00','99.7',
    '2022-09-11 15:00:00+02:00','99',
    '2022-09-11 16:00:00+02:00','98',
    '2022-09-11 17:00:00+02:00','101.59',
    '2022-09-11 18:00:00+02:00','115.54',
    '2022-09-11 19:00:00+02:00','175.36',
    '2022-09-11 20:00:00+02:00','192.98',
    '2022-09-11 21:00:00+02:00','251.5',
    '2022-09-11 22:00:00+02:00','220.98',
    '2022-09-11 23:00:00+02:00','191.78',
    ];


const rawTariff2=[
    '2022-09-11 00:00:00+02:00','444.08i',
    '2022-09-11 01:00:00+02:00','445.71i',
    '2022-09-11 02:00:00+02:00','453.69i',
    '2022-09-11 03:00:00+02:00','458.87i',
    '2022-09-11 04:00:00+02:00','462.06i',
    '2022-09-11 05:00:00+02:00','461.64i',
    '2022-09-11 06:00:00+02:00','456.13i',
    '2022-09-11 07:00:00+02:00','447.16i',
    '2022-09-11 08:00:00+02:00','397.12i',
    '2022-09-11 09:00:00+02:00','355.05i',
    '2022-09-11 10:00:00+02:00','270.71i',
    '2022-09-11 11:00:00+02:00','233.84i',
    '2022-09-11 12:00:00+02:00','220.87i',
    '2022-09-11 13:00:00+02:00','212.16i',
    '2022-09-11 14:00:00+02:00','196.38i',
    '2022-09-11 15:00:00+02:00','196.8i',
    '2022-09-11 16:00:00+02:00','196.69i',
    '2022-09-11 17:00:00+02:00','199.72i',
    '2022-09-11 18:00:00+02:00','233.92i',
    '2022-09-11 19:00:00+02:00','328.84i',
    '2022-09-11 20:00:00+02:00','359.76i',
    '2022-09-11 21:00:00+02:00','422.37i',
    '2022-09-11 22:00:00+02:00','392.89i',
    '2022-09-11 23:00:00+02:00','378.99i',
    ];


export let PoweUsedList = [];
export let PowePVList = [];
export let Tariff1List = [];
export let Tariff2List = [];

for(var i = 0; i < rawPowe_used.length-1; i=i+2){
    PoweUsedList.push({
        time: new Date(rawPowe_used[i]),
        value: parseFloat(rawPowe_used[i+1])
    })
}

for(i = 0; i < rawPowe_PV.length-1; i=i+2){
    PowePVList.push({
        time: new Date(rawPowe_PV[i]),
        value: parseFloat(rawPowe_PV[i+1])
    })
}

for(i = 0; i < rawTariff1.length-1; i=i+2){
    Tariff1List.push({
        time: new Date(rawTariff1[i]),
        value: parseFloat(rawTariff1[i+1])
    })
    Tariff1List.push({
        time: new Date(rawTariff1[i]),
        value: parseFloat(rawTariff1[i+1])
    })
    Tariff1List.push({
        time: new Date(rawTariff1[i]),
        value: parseFloat(rawTariff1[i+1])
    })
    Tariff1List.push({
        time: new Date(rawTariff1[i]),
        value: parseFloat(rawTariff1[i+1])
    })
}

for(i = 0; i < rawTariff2.length-1; i=i+2){
    Tariff2List.push({
        time: new Date(rawTariff2[i]),
        value: parseFloat(rawTariff2[i+1])
    })
    Tariff2List.push({
        time: new Date(rawTariff2[i]),
        value: parseFloat(rawTariff2[i+1])
    })
    Tariff2List.push({
        time: new Date(rawTariff2[i]),
        value: parseFloat(rawTariff2[i+1])
    })
    Tariff2List.push({
        time: new Date(rawTariff2[i]),
        value: parseFloat(rawTariff2[i+1])
    })
    
}